import { v4 as uuidv4 } from 'uuid';
import Img1 from '../../assets/img/project/project1.jpg';

const portfolioOneData = [
    {
        id: uuidv4(),
        image: Img1,
        category: 'Industrial',
        client: 'Rosalina D.',
        heading: 'Leverage agile motive frameworks',
        desc: 'Testfabrics is a world-leading producer and distributor of textile testing media. They offer a wide range of textile testing services to meet the needs of their clients, including quality assurance testing, colorfastness testing, physical testing, and flammability testing. nisi ut aliqui',
        btnText: 'Case Details',
    },

    {
        id: uuidv4(),
        image: Img1,
        category: 'Industrial',
        client: 'Rosalina D.',
        heading: 'Leverage agile motive frameworks',
        desc: 'Testfabrics is a world-leading producer and distributor of textile testing media. They offer a wide range of textile testing services to meet the needs of their clients, including quality assurance testing, colorfastness testing, physical testing, and flammability testing. nisi ut aliqui',
        btnText: 'Case Details',
    },

    {
        id: uuidv4(),
        image: Img1,
        category: 'Industrial',
        client: 'Rosalina D.',
        heading: 'Leverage agile motive frameworks',
        desc: 'Testfabrics is a world-leading producer and distributor of textile testing media. They offer a wide range of textile testing services to meet the needs of their clients, including quality assurance testing, colorfastness testing, physical testing, and flammability testing. nisi ut aliqui',
        btnText: 'Case Details',
    },

    {
        id: uuidv4(),
        image: Img1,
        category: 'Industrial',
        client: 'Rosalina D.',
        heading: 'Leverage agile motive frameworks',
        desc: 'Testfabrics is a world-leading producer and distributor of textile testing media. They offer a wide range of textile testing services to meet the needs of their clients, including quality assurance testing, colorfastness testing, physical testing, and flammability testing. nisi ut aliqui',
        btnText: 'Case Details',
    },
];

export default portfolioOneData;
